import { type FC } from "react";
import DropdownWithMultiSelect, {
  type MultiselectAccountValue,
} from "../../UserAccounts/DropdownWithMultiselect/DropdownWithMultiSelect";
import { useTranslation } from "react-i18next";

export enum EmailOrderQuoteDropdownType {
  ORDER,
  QUOTE,
}

interface EmailOrderQuoteAccountProp {
  list: MultiselectAccountValue[];
  selected: string;
  onChange?: (ids: string) => void;
  type: EmailOrderQuoteDropdownType;
}
export const EmailOrderQuoteAccount: FC<EmailOrderQuoteAccountProp> = ({ list, selected, onChange, type }) => {
  const { t } = useTranslation();
  return (
    <DropdownWithMultiSelect
      items={list}
      value={selected ? selected.split(",") : []}
      label={t("page.orderQuoteSettings.modal.label.account")}
      onChange={(e) => onChange?.((e.target.value as string[]).join(" "))}
      data-test-id={
        "email-order-quote-AccountMultiselect" +
        (type === EmailOrderQuoteDropdownType.ORDER ? "-order-account" : "-quote-account")
      }
      className={"scha__dropdown-multi-select__email-order-quote-account-selector"}
    />
  );
};
